/**
 * This component sits in the app bar.  It provides a notification icon and if the user has 
 * unread notifications, it will display the count in a red badge.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Notifications from '@mui/icons-material/Notifications';
import { Badge, IconButton, Tooltip } from '@mui/material';


import { red } from '@mui/material/colors';


const abEnvironment = new AbEnvironment();

//defines how often to check for notifications.
const notificationCheckTime = 60000;  

const UserInfoNotificationsQuery = graphql`
query UserInfoNotificationsQuery($startDate: Datetime, $endDate: Datetime, $accountId: UUID, $userId: UUID, $notificationType: String, $notificationSubject: String, $viewed: Int, $rlimit: Int, $first: Int, $offset: Int) {
  getnotificationentriesforuser(startTs: $startDate, endTs: $endDate, accountId: $accountId, userId: $userId, notificationType: $notificationType, notificationSubject: $notificationSubject, viewed: $viewed, rlimit: $rlimit, first: $first, offset: $offset) {
    totalCount
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    notificationbadge: {
      marginRight: 14,
      marginTop: 6,
      color: red[600]
    },
    notificationiconbutton: {
      width: 34,
      height: 34,
      marginRight: 12,
      padding: 4
    },
    notificationicon: {
      width: 30,
      height: 30,
      color: "#444",
    }
});

class UserInfoNotifications extends Component {

    constructor(props) {
      super(props);
   
      this.timer = null;
      this.auth = this.props.auth;
 
      this.state = {
        fetchCount: 0
      };  


    }

    componentDidMount() {
      if (this.timer === null) {
        //console.log('starting timer');
        this.timer = setInterval(() => this.checkEnvironmentAndQuery(), notificationCheckTime);
      }

   }
  
    componentWillUnmount() {
      //console.log('clearing timer');
      if (this.timer != null) {
        clearInterval(this.timer);
      }
      this.timer = null;
    }

    checkEnvironmentAndQuery() {
      //This does not call isAuthenticated for a reason.  We track user activity there 
      //and this should NOT count.
      let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
      if (expiresAt !== null) {
        this.setState({fetchCount: this.state.fetchCount + 1});
      } else {
        clearInterval(this.timer);
      }

      // This method invokes a check for inactivation.
      this.auth.checkForSessionInactivation();
    }

    gotoNotificationPage() {
      if (window.location.pathname === '/notification') {
        window.location.reload();
      } else {
        this.props.history.push(`/notification`);
      }
    }

    render() {
      const classes = this.props.classes;
      //console.log("looking for notifications");

      //note this will render an empty notification icon when fetching to minimize flicker.
      //most components show a spinner but that is distracting in this case.
      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={UserInfoNotificationsQuery}
          variables={{accountId: abEnvironment.getUserAttribute("a_id"),
                      userId: abEnvironment.getUserAttribute("u_id"),
                      viewed: 0,
                      fetchCount: this.state.fetchCount}}
          render={({error, props})=> {
            if (error) {
              return <span></span>
            } else if (props) {
              // Determine offset information
              let totalCount = props.getnotificationentriesforuser.totalCount;

              return (
                <span>
                      { totalCount > 0 && (
                      <Tooltip id="tooltip-n" title="Notifications" placement="bottom">
                      <Badge 
                        className={classes.notificationbadge} 
                        badgeContent={totalCount} 
                        color="error"
                        overlap="circular"
                        max={9}
                        onClick={() => {this.gotoNotificationPage()}}
                        >
                        <Notifications className={classes.notificationicon}/>
                      </Badge>
                      </Tooltip>
                      )}
                      {totalCount <= 0 && (
                      <Tooltip id="tooltip-n" title="Notifications" placement="bottom">
                      <IconButton
                        className={classes.notificationiconbutton}
                        color="secondary"
                        onClick={() => {this.gotoNotificationPage()}}
                        size="large">
                        <Notifications className={classes.notificationicon}/>
                      </IconButton>
                      </Tooltip>
                      )}
                </span>
              );
            }
            return (
              <Tooltip id="tooltip-n" title="Notifications" placement="bottom">
                <IconButton className={classes.notificationiconbutton} color="primary" size="large">
                  <Notifications className={classes.notificationicon}/>
                </IconButton>
              </Tooltip>
            );
          }}
        />
      );
    }
}
  
UserInfoNotifications.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(UserInfoNotifications);